import React, { useState } from 'react';
import { useCRM } from '../../context/CRMContext';
import PlaybookOverview from './PlaybookOverview';
import OnboardingManager from './OnboardingManager';
import ScenarioManager from './ScenarioManager';
import BattlecardManager from './BattlecardManager';
import CoachFeed from './CoachFeed';
import LearningCenter from './LearningCenter';
import SafeIcon from '../../common/SafeIcon';
import SignalFeed from '../lead-intel/SignalFeed';
// NEW IMPORT
import LeadIntelStarterKit from '../lead-intel/LeadIntelStarterKit';

const PlaybookCanvas = ({ projectId }) => {
  const { currentUser, permissions } = useCRM();
  const [activeTab, setActiveTab] = useState('overview');
  // New state for sub-navigation within Signals tab
  const [signalSubTab, setSignalSubTab] = useState('feed'); 

  const isCustomer = currentUser.role === 'Customer_Viewer';

  const allTabs = [
    { id: 'overview', label: 'Oversikt', icon: '📋', allowed: true },
    { id: 'onboarding', label: 'Onboarding', icon: '🚀', allowed: true },
    { id: 'scenarios', label: 'Scenarioer', icon: '🎭', allowed: !isCustomer },
    { id: 'battlecards', label: 'Battlecards', icon: '⚔️', allowed: !isCustomer },
    { id: 'learning', label: 'E-læring', icon: '🎓', allowed: !isCustomer },
    // INTEGRATION POINT
    { id: 'signals', label: 'Signals & Score', icon: '📡', allowed: !isCustomer && permissions.canOutreach },
    { id: 'coach', label: 'AI Coach', icon: '🤖', allowed: !isCustomer },
  ];

  const visibleTabs = allTabs.filter(t => t.allowed);

  return (
    <div className="bg-slate-50/50 min-h-[600px] rounded-b-2xl">
      {/* Sub-navigation */}
      <div className="px-8 border-b border-slate-200 bg-white sticky top-0 z-10">
        <div className="flex space-x-6 overflow-x-auto no-scrollbar">
          {visibleTabs.map(tab => (
            <button 
              key={tab.id} 
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 py-4 text-xs font-black uppercase tracking-widest border-b-2 transition-all whitespace-nowrap ${activeTab === tab.id ? 'border-slate-900 text-slate-900' : 'border-transparent text-slate-400 hover:text-slate-600 hover:border-slate-200'}`}
            >
              <SafeIcon icon={tab.icon} className="w-4 h-4" />
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content Area */}
      <div className="p-8">
        {activeTab === 'overview' && <PlaybookOverview projectId={projectId} />}
        {activeTab === 'onboarding' && <OnboardingManager projectId={projectId} />}
        {activeTab === 'scenarios' && <ScenarioManager projectId={projectId} />}
        {activeTab === 'battlecards' && <BattlecardManager projectId={projectId} />}
        {activeTab === 'learning' && <LearningCenter projectId={projectId} />}
        {activeTab === 'coach' && <CoachFeed projectId={projectId} />}
        
        {/* UPDATED SIGNALS TAB */}
        {activeTab === 'signals' && (
          <div className="space-y-6">
            <div className="flex justify-between items-center bg-indigo-50 border border-indigo-100 p-6 rounded-2xl">
              <div>
                <h3 className="text-lg font-black text-indigo-900">Prosjekt Intelligence</h3>
                <p className="text-sm text-indigo-700">Sanntidssignaler og automatiserte regler for dette prosjektet.</p>
              </div>
              <div className="flex bg-white p-1 rounded-xl border border-indigo-100 shadow-sm">
                <button 
                  onClick={() => setSignalSubTab('feed')}
                  className={`px-4 py-2 rounded-lg text-xs font-bold uppercase tracking-widest transition-all ${signalSubTab === 'feed' ? 'bg-indigo-600 text-white' : 'text-slate-500 hover:text-indigo-600'}`}
                >
                  Live Feed
                </button>
                <button 
                  onClick={() => setSignalSubTab('setup')}
                  className={`px-4 py-2 rounded-lg text-xs font-bold uppercase tracking-widest transition-all ${signalSubTab === 'setup' ? 'bg-indigo-600 text-white' : 'text-slate-500 hover:text-indigo-600'}`}
                >
                  Oppsett / Regler
                </button>
              </div>
            </div>
            
            {signalSubTab === 'feed' ? <SignalFeed /> : <LeadIntelStarterKit projectId={projectId} />}
          </div>
        )}
      </div>
    </div>
  );
};

export default PlaybookCanvas;